import React, { useRef, useEffect, forwardRef, useImperativeHandle } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const Captcha = forwardRef(({ onVerify, onExpire, onError, siteKey, theme = 'light', size = 'normal' }, ref) => {
  const recaptchaRef = useRef(null);

  const handleChange = (token) => {
    if (token) {
      onVerify(token);
    }
  };

  const handleExpire = () => {
    if (onExpire) {
      onExpire();
    }
  };

  const handleError = (error) => {
    if (onError) {
      onError(error);
    }
  };

  const reset = () => {
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
    }
  };

  // Expose reset method to parent component via ref
  useImperativeHandle(ref, () => ({
    reset: reset
  }));

  return (
    <div className="flex justify-center">
      <ReCAPTCHA
        ref={recaptchaRef}
        sitekey={siteKey}
        onChange={handleChange}
        onExpired={handleExpire}
        onErrored={handleError}
        theme={theme}
        size={size}
      />
    </div>
  );
});

export default Captcha;
